import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const PartnerSelectionModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (!isOpen) return null;

  const handleNavigate = (path) => {
    onClose();
    navigate(path);
  };

  return createPortal(
    <div className="fixed inset-0 z-[100] bg-background/80 backdrop-blur-md flex items-center justify-center p-4 sm:p-6 animate-in fade-in duration-300">
      
      {/* GLAVNI MODAL KONTEJNER */}
      <div 
        className="relative bg-card border border-border/60 rounded-[2.5rem] p-6 sm:p-10 max-w-2xl w-full shadow-[0_30px_70px_-15px_rgba(0,0,0,0.5)] overflow-hidden animate-in zoom-in-95 duration-300 space-y-8"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Pozadinski sjaj (Glow effect) */}
        <div className="absolute -top-24 -right-24 w-60 h-60 bg-gradient-to-br from-amber-500/20 to-orange-600/20 rounded-full blur-3xl pointer-events-none" />

        {/* ZAGLAVLJE MODALA */}
        <div className="flex items-start justify-between gap-4 border-b border-border/40 pb-6">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center text-white shadow-xl shadow-amber-500/20">
              <Icon name="Handshake" size={28} strokeWidth={2.5} />
            </div>
            <div>
              <h2 className="text-2xl sm:text-3xl font-black tracking-tight text-foreground">
                {t('adminHome.partnerModal.title', { defaultValue: 'Partneri' })}
              </h2>
              <p className="text-xs sm:text-sm font-semibold text-muted-foreground">
                {t('adminHome.partnerModal.subtitle', { defaultValue: 'Izaberite opciju za nastavak' })}
              </p>
            </div>
          </div>

          {/* DUGME ZA ZATVARANJE */}
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-2xl bg-muted/50 border border-border/40 flex items-center justify-center text-muted-foreground hover:text-foreground hover:bg-muted transition-all"
          >
            <Icon name="X" size={20} strokeWidth={2.5} />
          </button>
        </div>

        {/* DVA VELIKA MODERNA DUGMETA */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          
          {/* DUGME 1: NOVI PARTNER */}
          <button
            onClick={() => handleNavigate('/crea-partner')}
            className="group relative flex flex-col justify-between bg-card border border-border/60 hover:border-amber-500/50 rounded-[2rem] p-6 text-left transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-amber-500/10"
          >
            <div className="flex justify-between items-start mb-6">
              <div className="w-12 h-12 rounded-xl bg-amber-500/10 text-amber-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <Icon name="UserPlus" size={24} strokeWidth={2.5} />
              </div>
              <div className="w-8 h-8 rounded-lg bg-muted/50 flex items-center justify-center group-hover:bg-amber-500 group-hover:text-white transition-all">
                <Icon name="ArrowRight" size={16} strokeWidth={3} />
              </div>
            </div>

            <div>
              <h3 className="text-lg font-black text-foreground mb-1 group-hover:text-amber-500 transition-colors">
                {t('adminHome.partnerModal.newPartner.title', { defaultValue: 'NOVI PARTNER' })}
              </h3>
              <p className="text-xs text-muted-foreground leading-relaxed font-medium">
                {t('adminHome.partnerModal.newPartner.desc', { defaultValue: 'Dodajte novog klijenta ili dobavljača u bazu sa svim podacima.' })}
              </p>
            </div>
          </button>

          {/* DUGME 2: SVI PARTNERI */}
          <button
            onClick={() => handleNavigate('/lista-partner')}
            className="group relative flex flex-col justify-between bg-card border border-border/60 hover:border-orange-500/50 rounded-[2rem] p-6 text-left transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-orange-500/10"
          >
            <div className="flex justify-between items-start mb-6">
              <div className="w-12 h-12 rounded-xl bg-orange-500/10 text-orange-500 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <Icon name="Users" size={24} strokeWidth={2.5} />
              </div>
              <div className="w-8 h-8 rounded-lg bg-muted/50 flex items-center justify-center group-hover:bg-orange-500 group-hover:text-white transition-all">
                <Icon name="ArrowRight" size={16} strokeWidth={3} />
              </div>
            </div>

            <div>
              <h3 className="text-lg font-black text-foreground mb-1 group-hover:text-orange-500 transition-colors">
                {t('adminHome.partnerModal.allPartners.title', { defaultValue: 'SVI PARTNERI' })}
              </h3>
              <p className="text-xs text-muted-foreground leading-relaxed font-medium">
                {t('adminHome.partnerModal.allPartners.desc', { defaultValue: 'Pregledajte i upravljajte postojećom listom svih partnera i dokumenata.' })}
              </p>
            </div>
          </button>

        </div>
      </div>
    </div>,
    document.body
  );
};

export default PartnerSelectionModal;